import colorVariables from 'srcReact/assets/scss/global/base/_variables.scss'

export const appConstantSettings = {
  //File picker - rich text editor
  ACCEPTED_IMAGE_TYPES: 'png,jpg,jpeg,gif,tiff,webp',
  ACCEPTED_DOCUMENT_TYPES: 'doc,docx,ppt,pptx,xls,xlsx,pdf,key,keynote,numbers,odp,ods,odt,pages',
  ACCEPTED_ZIP_TYPES: '7z,arj,bz2,gz,rar,tgz,zip',
  CROPPER_ACCEPTED_IMAGE_TYPES: 'image/x-png,image/png,image/jpg,image/jpeg,image/gif,image/webp,image/tiff',
  PROFILE_PIC_MIN_SIZE: 250,
  MAX_IMAGE_SIZE_MB: 50,
  MAX_DOC_SIZE_MB: 100,
  MAX_LINES: 15,
  MAX_CHAR_COUNT: 8000,
  FILES_LIMIT: 20,
  FILE_SIZE_LIMIT_FOR_PREVIEW: 1, // in MB
  //Google Location
  GOOGLE_AUTOCOMPLETE_MIN_LENGTH: 4,
  IMAGE_CROPPER_FILE_SIZE_MB: 50,
  PAGINATION_QUANTITY: 20,
  WORKPLACE_PAGINATION_QUANTITY: 10,
  MIXR_PAGINATION_QUANTITY: 6,
  SHOW_MORE_MAX_LINES: 3,
  SHOW_MORE_MAX_CHARS: 300,
  //Interest picker
  MIN_INTEREST_COUNT: 1,
  MAX_INTEREST_COUNT: 15,
  MAX_COMMENTS_ON_FEED: 2,
  MIN_REPLIES_ON_FEED: 1,
  COMMENT_POPUP_TEXT_MAX_LENGTH: 100,
  //User location finder
  USER_LOCATION_FINDER: `https://ipapi.co/json`,
  USER_LOCATION_TIMEOUT: 60, // in minutes
  //Member overview mixr/group
  MAX_ORGANIZERS_DESKTOP: 6,
  MAX_TOTAL_DESKTOP: 11,
  MAX_ORGANIZERS_MOBILE: 3,
  MAX_TOTAL_MOBILE: 5,
  MAX_ORGANIZERS_TABLET: 5,
  MAX_TOTAL_TABLET: 8,
  //Default homepage
  DEFAULT_HOMEPAGE: 'myhome',
  //Search length
  SEARCH_LENGTH: 3,
  //Global search length
  GLOBAL_SEARCH_LENGTH: 2,
  //link preview
  ALLOWED_VIDEO_URLS: ['youtube.com'],
  DISABLED_SITES: ['docs.google.com'],

  //language
  LANG_COOKIE_NAME: 'mixr-lang',
  LANG_COOKIE_EXP_DAYS: 365,
  DEFAULT_LANGUAGE: 'en',

  //light profile
  MAX_GROUPS_MIXRS_DISPLAY: 5,

  //datetime formates
  EN_DATE_FORMAT1: 'ddd, MMM DD, YYYY', //  Mon, Jan 12, 2022
  FR_DATE_FORMAT1: 'ddd DD MMM YYYY', //  lun. 12 janv. 2022

  EN_DATE_FORMAT2: 'MMM DD, YYYY', //  Jan 12, 2022
  FR_DATE_FORMAT2: 'DD MMM YYYY', //  12 janv. 2022

  EN_DATE_FORMAT3: 'MM/DD/YYYY', //  01/12/2022
  FR_DATE_FORMAT3: 'DD/MM/YYYY', //  12/01/2022

  EN_DATE_FORMAT4: 'MMM DD', // Jan 12
  FR_DATE_FORMAT4: 'DD MMM', // 12 janv.
  DATE_FORMAT5: 'ddd, DD MMM', //  Mon 12 Jan

  EN_DATE_FORMAT6: 'dddd, MMM DD YYYY', //  Monday, Jan 12 2022
  FR_DATE_FORMAT6: 'dddd, DD MMM YYYY', //  lundi, 12 janv. 2022

  DATE_FORMAT7: 'YYYY-MM-DD HH:mm:ss', //used for api purpose
  DATE_FORMAT8: 'YYYY-MM-DD', //used for api purpose

  EN_DATE_FORMAT9: 'dddd, MMMM DD', //  Monday, January 12
  FR_DATE_FORMAT9: 'dddd, DD MMMM', //  lundi, 12 janvier

  EN_DATE_FORMAT10: 'MMMM D YYYY', //  Monday, January 12
  FR_DATE_FORMAT10: 'D MMMM YYYY', //  lundi, 12 janvier

  EN_DATETIME_FORMAT11: 'MMM D, YYYY - hh:mm A', //  Jan 12 2022 - 05:30 PM
  FR_DATETIME_FORMAT11: 'D MMM, YYYY - HH:mm', // 12 janv., 2022 - 17:30

  EN_TIME_FORMAT1: 'hh:mm A', //  01:30 PM
  EN_TIME_FORMAT2: 'hh:mmA', //  01:30PM
  FR_TIME_FORMAT: 'HH:mm', // 13:30
  WEEKDAY: 'ddd', //  Mon
  WEEKDAY_FULL: 'dddd', // Monday
  MONTH: 'MMM', //  Jan, janv.
  MONTH_FULL: 'MMMM', //  January, janvier
  DAY: 'D', // 1
  DAY_ZERO_PADDED: 'DD', //01

  //pricing
  FREE_TRIAL_DAYS: 30,

  //EU Countries pricing
  EU_YEARLY_ESSENTIAL: '€3',
  EU_YEARLY_PRO: '€5',
  EU_YEARLY_ESSENTIAL_NONPROFIT: '€1.2',
  EU_YEARLY_PRO_NONPROFIT: '€2',
  EU_MONTHLY_ESSENTIAL: '€3.60',
  EU_MONTHLY_PRO: '€6',
  EU_MONTHLY_ESSENTIAL_NONPROFIT: '€1.44',
  EU_MONTHLY_PRO_NONPROFIT: '€2.4',

  //Default pricing
  YEARLY_ESSENTIAL: '$3',
  YEARLY_PRO: '$5',
  YEARLY_ESSENTIA_NONPROFIT: '$1.2',
  YEARLY_PRO_NONPROFIT: '$2',
  MONTHLY_ESSENTIAL: '$3.60',
  MONTHLY_PRO: '$6',
  MONTHLY_ESSENTIA_NONPROFIT: '$1.44',
  MONTHLY_PRO_NONPROFIT: '$2.4',

  // User pageview list
  MYHOME_PAGE: 'myhome',
  DISCOVER_PAGE: 'discover',
  CALENDAR_PAGE: 'calendar',
  GROUP_PAGE: 'group',
  EVENT_PAGE: 'event',
  PROFILE_PAGE: 'profile',

  //API
  RETRY_COUNT: 4,
  RETRY_DURATION: 2000, //2 seconds

  //Default classname for div tag
  DIV_TAG_CONTAINER: 'divTagContainer',

  //organization list count
  ORG_LIST_QTY: 10,

  //sidebar list count
  SIDEBAR_LIST_QTY: 5,

  // Accronym maxLength
  ACCRONYM_MAXLENGHT: '4',

  // Default color
  DEFAULT_COLOR: { name: 'green', hex: colorVariables.greenmixr },

  //List of organization colors
  COLORS: [
    { name: 'green', hex: colorVariables.orgGreen },
    { name: 'red', hex: colorVariables.orgRed },
    { name: 'orange', hex: colorVariables.orgOrange },
    { name: 'blue', hex: colorVariables.orgBlue },
    { name: 'violet', hex: colorVariables.orgViolet }
  ],

  //List of workplace roles colors
  WORKPLACE_ROLES_COLORS: [
    { role: 'workplace-manager', hex: colorVariables.highlightedText },
    { role: 'workplace-member', hex: colorVariables.bluePurple }
  ],

  // Save draft message timout
  SAVE_DRAFT_MESSAGE_TIMOUT: 2000, //2seconds

  // Minimum age to user register
  MINIMUM_AGE: 16,

  ///caching
  AVATAR_CACHE_LIMIT: 50, //max 50 records (base 64 image urls)
  MEDIA_CACHE_LIMIT: 50, //max 50 records (base 64 image urls)

  //error codes.
  HTTP500: 'http-500',

  // CTA button display on myHome and Discover (mixrs and groups section)
  CTA_BUTTON_DISPLAY: 5,

  // CTA button join call on myHome when mixr time is < 5 minutes (mixrs section)
  CTA_BUTTON_JOIN_CALL: 5,
  REFRESH_INTERVAL_JOIN_CALL: 60 * 1000,

  //enable image optiomization with imagekit
  ENABLE_COMPRESSION: true,

  //General feed CTA
  FEED_COUNT_FOR_CTA: 3,

  //contact us
  MESSAGE_MAX_LEN: 1000,
  SUBJECT_MAX_LEN: 100,

  // myHome mixr tab enable or disable
  ENABLE_MYHOME_CAROUSEL_TAB: false,

  //workplace and organization name max length
  WP_NAME_MAXLENGTH: 60,
  ORG_NAME_MAXLENGTH: 60,

  // update profile and cover picture for native side
  NATIVE_PICTURE_UPDATE_INTERVAL: 2000, //2seconds

  //My profile
  CHALLANGE_WORD_COUNT: 50,
  CHALLENGE_INTERESTS: 5,
  CHALLENGE_EXPERTISE: 3,
  CHALLENGE_PROMPT: 3,
  MY_PROFILE_CTA_DURATION: 604800, // in seconds (7 days)

  //welcome banner
  WELCOME_BANNER_INTERVAL: 10000 // 10 seconds
}
